import type { ReactNode } from "react";

// The Project Hub's one section header. Before this the hub had three different
// header treatments — two sitting above their cards, one inside a card, and one
// built from inline styles whose h3 fell through to the 19px base size. That
// last one made "Audio Files" render LARGER than the "Assets" heading it sits
// under, which read as a flat list of peers rather than a section containing
// cards.
//
// So the hub now has exactly two levels, and they are visually ranked:
//   SectionHead  — Essentials / Assets / Services, above the cards
//   .card-head   — Manuscript / Audio Files, inside a card, quieter
//
// `right` is for section-level status or actions; it stays out of the title so
// a long subtitle and a status chip can't fight for the same line.
export function SectionHead({
  title,
  sub,
  right,
}: {
  title: string;
  sub?: ReactNode;
  right?: ReactNode;
}) {
  return (
    <div className="sec-head">
      <div className="sec-head-text">
        <h3>{title}</h3>
        {sub != null && <span className="muted sec-sub">{sub}</span>}
      </div>
      {right != null && <div className="sec-head-right">{right}</div>}
    </div>
  );
}
